const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    border: '1px dashed #CBD0D7',
    borderRadius: '10px',
    padding: '14px 16px',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
    backgroundColor: '#fff',
    transition: 'background-color 0.2s, border-color 0.2s',
    '&:hover': {
      borderColor: '#015FFB',
      backgroundColor: 'rgba(1,95,251,.03)',
    },
  },
  contentSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
  },
  textSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    alignItems: 'flex-start', // Align text to start
  },
  iconContainer: {
    backgroundColor: '#fff', // Or transparent? Screenshot doesn't show background on icon clearly, maybe just the icon.
    // Wait, the screenshot shows just the icon.
    // My previous code had a white box with shadow. I'll stick to a simple icon or minimal styling if not specified.
    // The previous design I implemented had a box. The screenshot shows just an icon? Hard to tell if it's in a box from the small crop, but likely just the icon.
    // Let's use the icon directly or in a minimal wrapper.
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    color: '#637381',
    fontSize: '22px',
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#002E47',
  },
  subtitle: {
    fontSize: '12px', // Slightly smaller for subtitle
    color: '#919EAB',
  },
})
export default styles
